import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import links from 'utils/links';
import styles from './Page404.module.css';

const Page404 = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const title = t('pageNotFound');

  useEffect(() => {
    // The tab title is set here because this page often mounts after the
    // session check, and Helmet does not update the title on that later mount.
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{t('pageNotFound')}</title>
      </Helmet>
      <div className={styles.page}>
        <p className={styles.code}>404</p>
        <h1 className={styles.title}>{t('pageNotFound')}</h1>
        <p className={styles.message}>{t('pageNotFoundDescription')}</p>
        <Link className={styles.homeLink} to={links.home()}>
          {t('backToHome')}
        </Link>
      </div>
    </>
  );
};

export default Page404;
